import { createContext } from "react";
import type { useAffinityFormReturn } from "affinityForm";

import { HospitalConfigurationType } from "./types";

export const SettingsFormContext = createContext<Maybe<useAffinityFormReturn<HospitalConfigurationType>>>(null);
